import { render, staticRenderFns } from "./ChannelListSidebar.vue?vue&type=template&id=492f23eb&"
import script from "./ChannelListSidebar.vue?vue&type=script&lang=js&"
export * from "./ChannelListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ChannelListSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports